module.exports = __webpack_public_path__ + "img/loading.a3f09cb9.svg";